var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsSixVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 5.625C7.70527 5.625 8.125 5.20527 8.125 4.6875C8.125 4.16973 7.70527 3.75 7.1875 3.75C6.66973 3.75 6.25 4.16973 6.25 4.6875C6.25 5.20527 6.66973 5.625 7.1875 5.625Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 5.625C13.3303 5.625 13.75 5.20527 13.75 4.6875C13.75 4.16973 13.3303 3.75 12.8125 3.75C12.2947 3.75 11.875 4.16973 11.875 4.6875C11.875 5.20527 12.2947 5.625 12.8125 5.625Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 10.9355C7.70527 10.9355 8.125 10.5158 8.125 9.99805C8.125 9.48028 7.70527 9.06055 7.1875 9.06055C6.66973 9.06055 6.25 9.48028 6.25 9.99805C6.25 10.5158 6.66973 10.9355 7.1875 10.9355Z",
    fill: "#1A181E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 10.9355C13.3303 10.9355 13.75 10.5158 13.75 9.99805C13.75 9.48028 13.3303 9.06055 12.8125 9.06055C12.2947 9.06055 11.875 9.48028 11.875 9.99805C11.875 10.5158 12.2947 10.9355 12.8125 10.9355Z",
    fill: "#1A181E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 16.25C7.70527 16.25 8.125 15.8303 8.125 15.3125C8.125 14.7947 7.70527 14.375 7.1875 14.375C6.66973 14.375 6.25 14.7947 6.25 15.3125C6.25 15.8303 6.66973 16.25 7.1875 16.25Z",
    fill: "#1A181E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8125 16.25C13.3303 16.25 13.75 15.8303 13.75 15.3125C13.75 14.7947 13.3303 14.375 12.8125 14.375C12.2947 14.375 11.875 14.7947 11.875 15.3125C11.875 15.8303 12.2947 16.25 12.8125 16.25Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsSixVertical);
export default __webpack_public_path__ + "static/media/dots-six-vertical.4b8254d0e4fde1fbfc7f9fde6259f052.svg";
export { ForwardRef as ReactComponent };